var _path, _path2, _path3, _path4, _g, _path5, _path6, _path7, _path8, _g2, _path9, _path10, _g3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCoinLtr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 43,
    viewBox: "0 0 42 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.08 1.05985L31.3634 3.39144C32.2097 3.70552 32.9335 4.26301 33.4994 4.98654L39.9564 12.839C40.798 13.8574 41.2673 15.187 41.2225 16.5183L40.9048 28.7886C40.8778 30.1586 40.3398 31.4352 39.4132 32.3751L33.4577 38.477C32.8648 39.1235 32.088 39.5734 31.2613 39.8121L24.4151 41.8285L24.08 1.05985Z",
    fill: "url(#paint0_linear_1343_36069)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7699 1.02244L12.5572 2.09221C11.4548 2.03607 10.3927 2.47634 9.64186 3.28885L2.26225 12.1037C1.60968 12.8243 1.21504 13.8011 1.20078 14.7908L0.984312 25.7507C0.970053 26.7403 1.33617 27.7427 1.97623 28.5259L9.03982 38.7216C9.77177 39.6031 10.8018 40.1137 11.9429 40.1521L23.1724 41.9771C24.2749 42.0332 25.3369 41.5929 26.0878 40.7804L34.7373 31.5704C35.3899 30.8498 35.8023 29.9116 35.7988 28.8833L36.0162 15.0674C36.0304 14.0778 35.6643 13.0753 35.0243 12.2922L26.673 2.45296C25.9233 1.53284 24.8933 1.02217 23.7699 1.02244Z",
    fill: "url(#paint1_linear_1343_36069)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5501 5.87924L13.2595 6.68556C12.4423 6.63903 11.6688 6.9938 11.0967 7.58384L5.65712 14.1982C5.16245 14.7528 4.87251 15.4475 4.84691 16.2082L4.66682 24.3895C4.64122 25.1503 4.92184 25.8642 5.37811 26.4508L10.5875 34.0327C11.118 34.6789 11.9046 35.0671 12.704 35.075L20.9984 36.4203C21.8156 36.4669 22.5891 36.1121 23.1611 35.5221L29.5613 28.6544C30.056 28.0999 30.3459 27.4051 30.3715 26.6444L30.5478 16.3114C30.5734 15.5507 30.2928 14.8368 29.8366 14.2502L23.6666 6.92151C23.1152 6.33175 22.3673 5.92578 21.5501 5.87924Z",
    fill: "#F08F3B"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1343_36069",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 5,
    width: 27,
    height: 32
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5501 5.87924L13.2595 6.68556C12.4423 6.63903 11.6688 6.9938 11.0967 7.58384L5.65712 14.1982C5.16245 14.7528 4.87251 15.4475 4.84691 16.2082L4.66682 24.3895C4.64122 25.1503 4.92184 25.8642 5.37811 26.4508L10.5875 34.0327C11.118 34.6789 11.9046 35.0671 12.704 35.075L20.9984 36.4203C21.8156 36.4669 22.5891 36.1121 23.1611 35.5221L29.5613 28.6544C30.056 28.0999 30.3459 27.4051 30.3715 26.6444L30.5478 16.3114C30.5734 15.5507 30.2928 14.8368 29.8366 14.2502L23.6666 6.92151C23.1152 6.33175 22.3673 5.92578 21.5501 5.87924Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1343_36069)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.7759 5.93517L15.4853 6.7415C14.6682 6.69496 13.8946 7.04974 13.3226 7.63978L7.88297 14.2541C7.3883 14.8087 7.09836 15.5034 7.07276 16.2642L6.89267 24.4454C6.86707 25.2062 7.14769 25.9201 7.60396 26.5067L12.8134 34.0887C13.3438 34.7348 14.1304 35.1231 14.9299 35.1309L23.2243 36.4763C24.0414 36.5228 24.815 36.168 25.387 35.578L31.7871 28.7104C32.2818 28.1558 32.5718 27.4611 32.5974 26.7003L32.7737 16.3674C32.7993 15.6066 32.5187 14.8927 32.0624 14.3061L25.8924 6.97745C25.362 6.33127 24.5931 5.98171 23.7759 5.93517Z",
    fill: "#FFA42F"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1749 30.3378L17.0144 30.8979L21.9932 11.9489L26.2361 14.8716C26.5714 15.0923 26.847 15.3872 27.0244 15.774C27.4711 16.6458 27.9244 18.4509 26.8711 21.4619C26.156 23.4751 24.2646 26.496 22.6549 28.4982C22.1152 29.2607 21.0371 30.1764 20.1749 30.3378Z",
    fill: "#F08F3B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3255 13.7987C15.9212 9.63115 23.7628 11.4182 25.427 15.149C27.7089 20.3286 20.4136 31.1646 16.7291 30.8883C13.7667 30.6553 6.78948 17.892 11.3255 13.7987Z",
    fill: "url(#paint2_linear_1343_36069)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4876 16.8797C12.9816 17.2054 12.6417 17.6891 12.6047 18.2209C12.5405 18.9994 12.7277 20.2243 14.082 21.8502C16.4439 24.6525 17.3809 20.5713 17.1227 19.1917C16.6822 17.0063 15.3538 15.743 13.4876 16.8797Z",
    fill: "#E17E3B"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1343_36069",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 16,
    width: 6,
    height: 7
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4876 16.8797C12.9816 17.2054 12.6417 17.6891 12.6047 18.2209C12.5405 18.9994 12.7277 20.2243 14.082 21.8502C16.4439 24.6525 17.3809 20.5713 17.1227 19.1917C16.6822 17.0063 15.3538 15.743 13.4876 16.8797Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1343_36069)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.313 17.2503C13.807 17.576 13.467 18.0596 13.4301 18.5915C13.3658 19.37 13.5531 20.5948 14.9073 22.2208C17.2692 25.023 18.2063 20.9418 17.948 19.5622C17.4898 17.3381 16.2178 16.0958 14.313 17.2503Z",
    fill: "#F8902C"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7016 18.3279C24.0742 19.1401 24.0422 20.091 23.4847 20.8148C23.0078 21.4081 22.2423 22.0868 20.8113 22.7432C17.0596 24.4638 18.2769 19.9732 19.2517 18.7303C20.784 16.7636 22.6341 16.1023 23.7016 18.3279Z",
    fill: "#E27A36"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_1343_36069",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 16,
    width: 6,
    height: 8
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7016 18.3279C24.0742 19.1401 24.0422 20.091 23.4847 20.8148C23.0078 21.4081 22.2423 22.0868 20.8113 22.7432C17.0596 24.4638 18.2769 19.9732 19.2517 18.7303C20.784 16.7636 22.6341 16.1023 23.7016 18.3279Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_1343_36069)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.3722 18.7693C24.7448 19.5815 24.7128 20.5324 24.1553 21.2562C23.6783 21.8495 22.9129 22.5282 21.4819 23.1845C17.7301 24.9052 18.9475 20.4146 19.9223 19.1717C21.4546 17.205 23.266 16.5614 24.3722 18.7693Z",
    fill: "#F8902C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1343_36069",
    x1: 30.763,
    y1: 32.3708,
    x2: 33.8214,
    y2: 8.38627,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0196,
    stopColor: "#E48818"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4383,
    stopColor: "#E48A19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5891,
    stopColor: "#E6911E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6966,
    stopColor: "#E99C27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.783,
    stopColor: "#ECAD34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8296,
    stopColor: "#EFBA3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.843,
    stopColor: "#EEB839"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8845,
    stopColor: "#ECB632"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBB530"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1343_36069",
    x1: 8.13228,
    y1: 38.6724,
    x2: 27.54,
    y2: 7.07694,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0196,
    stopColor: "#FFBF20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4599,
    stopColor: "#FABF36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7859,
    stopColor: "#FAD64D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAE95F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1343_36069",
    x1: 10.9005,
    y1: 23.0265,
    x2: 26.362,
    y2: 17.9961,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0196,
    stopColor: "#FACA4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3908,
    stopColor: "#FACD4E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7089,
    stopColor: "#FAD855"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAE95F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoinLtr);
export default __webpack_public_path__ + "static/media/coin-ltr.3babcaec79b20b4ce50d560a4dfbc11c.svg";
export { ForwardRef as ReactComponent };